// UX pass 2026-10-25 (Val: "Old Sidebar was flyover/hover activated please bring that back as a user option").
// Each person chooses how the left menu behaves; the choice is stored per login (user_preferences, like the CRM view
// mode), with a browser copy for a fast first paint.
//   hover  - "Expand on hover": a slim icon rail; resting the pointer on it (or tabbing into it) flies the full menu out
//            OVER the page, so the page never jumps. It tucks away when the pointer or keyboard focus leaves.
//   pinned - "Pinned open": the full menu stays open beside the page. The ☰ button can still fold it to the rail.
export const SIDEBAR_MODE_KEY = 'nav.sidebar.mode';
export const SIDEBAR_MODES = Object.freeze(['hover', 'pinned']);
export const DEFAULT_SIDEBAR_MODE = 'hover';
export const SIDEBAR_MODE_LABELS = Object.freeze({ hover: 'Expand on hover', pinned: 'Pinned open' });
